{
  "Accessibility Menu": "அணுகல் மெனு",
  "Reset settings": "அமைப்புகளை மீட்டமை",
  "Close": "மூடு",
  "Content Adjustments": "உள்ளடக்க சரிசெய்தல்கள்",
  "Adjust Font Size": "எழுத்துரு அளவை சரிசெய்",
  "Highlight Title": "தலைப்பை ஹைலைட் செய்",
  "Highlight Links": "இணைப்புகளை ஹைலைட் செய்",
  "Readable Font": "படிக்கக்கூடிய எழுத்துரு",
  "Color Adjustments": "நிற சரிசெய்தல்கள்",
  "Dark Contrast": "இருண்ட மாறுபாடு",
  "Light Contrast": "ஒளி மாறுபாடு",
  "High Contrast": "உயர் மாறுபாடு",
  "High Saturation": "உயர் நிறம்",
  "Low Saturation": "குறைந்த நிறம்",
  "Monochrome": "ஒற்றை நிறம்",
  "Tools": "கருவிகள்",
  "Reading Guide": "படிக்கும் வழிகாட்டி",
  "Stop Animations": "அனிமேஷன்களை நிறுத்து",
  "Big Cursor": "பெரிய கர்சர்",
  "Increase Font Size": "எழுத்துரு அளவை அதிகரிக்க",
  "Decrease Font Size": "எழுத்துரு அளவை குறைக்க",
  "Letter Spacing": "எழுத்து இடைவெளி",
  "Line Height": "வரி உயரம்",
  "Font Weight": "எழுத்துரு எடை",
  "Dyslexia Font": "டிஸ்லெக்சியா எழுத்துரு",
  "Language": "மொழி",
  "Open Accessibility Menu": "அணுகல் மெனுவை திற"
}
